import {useQuery} from 'react-query';
import {apiService} from '~services/ApiService';
import {useUserStore} from '~providers/userStore/zustand';

export interface PyxiSelectQuizData {
  user: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: {
      first_name?: string;
      last_name?: string;
      phone_number?: string;
      email?: string;
      date_of_birth?: string;
      gender?: string;
    };
  };
  general: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: {
      industry?: string;
      energy_preference?: string;
      three_words?: string;
    };
  };
  reset_table: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: {
      social_style?: string;
      social_preference?: string;
      interests?: string;
      dinner_price_preference?: string;
      political_engagement?: string;
      religious_engagement?: string;
    };
  };
  cultural_edit: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: {
      cultural_interests?: string;
      cultural_curiosity?: string;
      networking_preference?: string;
      social_preference_time?: string;
    };
  };
  neighborhood: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: Record<string, any>;
  };
  housewarming: {
    status: {
      filled: string[];
      not_filled: string[];
    };
    data: {
      drink_preference?: string;
    };
  };
}

export function useGetPyxiSelectAllData(enabled: boolean = true) {
  const userId = useUserStore.getState().user?.uid;

  return useQuery<PyxiSelectQuizData>(
    ['pyxiSelectAllData', userId],
    async () => {
      return await apiService.get<PyxiSelectQuizData>('pyxi-select/quiz/all-data');
    },
    {
      enabled: !!userId && enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}

export default useGetPyxiSelectAllData;